import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickComponentCommonProps } from "../../interfaces/commonProps.mjs.mjs";
import { useLocale } from "../LocaleProvider/index.mjs.mjs";
import { StyledStaticLabel, StyledAnimatedLabel, StyledOptionalText, } from "./FormLabel.styles.mjs.mjs";
export const FormLabel = ({ as, children, disabled = false, variant = 'default', empty = false, hideLabelOptional, invalid = false, htmlFor, required = false, readOnly = false, ...restProps }) => {
    let StyledLabel;
    switch (variant) {
        case 'scale':
        case 'float':
            StyledLabel = StyledAnimatedLabel;
            break;
        case 'static':
        case 'default':
        default:
            StyledLabel = StyledStaticLabel;
    }
    const locale = useLocale();
    const hasOptionalLabel = !required && !hideLabelOptional;
    return (React.createElement(StyledLabel, { as: as, "data-testid": `testid_${htmlFor}`, "$disabled": disabled, variant: variant, empty: empty, hideLabelOptional: hideLabelOptional, invalid: invalid, htmlFor: htmlFor, outerSpacing: useSpacing(restProps), "$required": required, "$readOnly": readOnly, ...pickComponentCommonProps(restProps) },
        children,
        ' ',
        hasOptionalLabel && (React.createElement(StyledOptionalText, null, locale.formLabel.optional))));
};
//# sourceMappingURL=FormLabel.mjs.mjs.map